import React from 'react'
import { Typography, CircularProgress } from '@material-ui/core'
import styled from '@emotion/styled'

const ChatBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: ${(props) => props.theme.spacing(2)};
`

const LoadingText = styled(Typography)`
  margin-top: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.palette.text.secondary};
`

export default function ChatLoadingState() {
  return (
    <ChatBody>
      <LoadingContainer>
        <CircularProgress />
        <LoadingText variant="body1">Processing your request...</LoadingText>
      </LoadingContainer>
    </ChatBody>
  )
}
